<template>
    <div class="home">
        <b-container fluid>
            <h1>Minnesota Nurse Aide Registry</h1>

            <b-row>
                <b-col>
                    <b-button variant="primary" @click="login">Login or Create Account</b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import axios from "axios"
    import axiosRetry from 'axios-retry'

    axiosRetry(axios, { retries: 3,
        retryDelay: axiosRetry.exponentialDelay  })

    export default {
        data: () => ({
            welcomeText: ''
        }),
        created() {
            document.title = "Minnesota Nurse Aide Registry - NAR"
        },
        methods: {
            login () {
               window.location.replace('/home')
            },
        }
    }
</script>

<style>
</style>